import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Box, Flex, Text, Button, Link
} from 'components/ui';
import Divider from 'components/Divider';
import theme from 'style/theme';
import { expandableOptionPaddingLeftSMUI } from 'components/ProductPage/DeliveryOptions/ExpandableDeliveryOptions/ExpandableDeliveryOptions';
import { useSDUBannerNDD } from './hooks/useSDUBannerNDD';

const VARIANT_STYLES = {
    fulfillmentLegacy: {
        dividerMarginTop: [3, 2],
        flexPaddingY: [3, 2],
        flexPaddingX: [4, 3],
        boxMarginLeft: [-expandableOptionPaddingLeftSMUI, -3],
        boxMarginRight: [-3, -2],
        boxMarginBottom: -3
    },
    fulfillmentChallenger: {
        dividerMarginTop: 3,
        flexPaddingY: 0,
        flexPaddingX: 0,
        flexPaddingTop: 3,
        boxMarginLeft: 0,
        boxMarginRight: 0,
        boxMarginBottom: 0
    }
};

function SDUBannerNDD({ skuTrialEligibility, renderSDULandingPage, variant = 'fulfillmentLegacy' }) {
    const { message, ctaLabel, showLinkCta, isBannerVisible } = useSDUBannerNDD({ skuTrialEligibility });
    const variantStyles = VARIANT_STYLES[variant] || VARIANT_STYLES.fulfillmentLegacy;

    if (!message || !isBannerVisible) {
        return null;
    }

    return (
        <Box
            marginLeft={variantStyles.boxMarginLeft}
            marginRight={variantStyles.boxMarginRight}
            marginBottom={variantStyles.boxMarginBottom}
        >
            <Divider marginTop={variantStyles.dividerMarginTop} />
            <Flex
                alignItems='center'
                justifyContent='space-between'
                paddingY={variantStyles.flexPaddingY}
                paddingX={variantStyles.flexPaddingX}
                paddingTop={variantStyles.flexPaddingTop}
                gap={5}
            >
                <Text
                    is='p'
                    fontSize='sm'
                    css={styles.messageText}
                    children={message}
                />

                {showLinkCta ? (
                    <Link
                        color='blue'
                        onClick={renderSDULandingPage}
                        children={ctaLabel}
                        flexShrink={0}
                    />
                ) : (
                    <Button
                        size='xs'
                        variant='secondary'
                        onClick={renderSDULandingPage}
                        children={ctaLabel}
                        flexShrink={0}
                        minWidth={88}
                    />
                )}
            </Flex>
        </Box>
    );
}

const styles = {
    messageText: {
        // !important needed to override parent element's font-size: 14px (base) from global styles
        // The banner message must be 12px (sm) per design spec, but parent context applies 14px
        fontSize: `${theme.fontSizes.sm}px !important`
    }
};

SDUBannerNDD.propTypes = {
    skuTrialEligibility: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    renderSDULandingPage: PropTypes.func.isRequired,
    variant: PropTypes.oneOf(['fulfillmentLegacy', 'fulfillmentChallenger'])
};

export default wrapFunctionalComponent(SDUBannerNDD, 'SDUBannerNDD');
